import React from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import Dropzone from './components/Dropzone'

import { DnDInputProvider } from './context/DnDInputContext'

const DnDinput = ({
  values,
  noClick,
  dropzoneClassName = '',
  errorMessage = '',
  onChange = null,
  title,
  heading = '',
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <DnDInputProvider>
        <Dropzone
          values={values}
          noClick={noClick}
          className={`${dropzoneClassName} ${
            errorMessage ? 'has-error' : ''
          }`.trim()}
          errorMessage={errorMessage}
          onChange={onChange}
          title={title}
          heading={heading}
        />
      </DnDInputProvider>
    </DndProvider>
  )
}

export default DnDinput
